export default {
  AUTOCHECK: 'A369',
  CAPITALONE: 'D52F',
  CARCHEX: '4FF6',
  EXPERIAN: 'DF45',
  WESTLAKE: 'W32D',
  LEAD_WITH_MY_WALLET: '719A',
  LEAD_WITH_TEST_DRIVE: 'T98D',
  EMAIL_LEAD: '56CB',
  PHONE_LEAD: 'CE23',
  CHAT_LEAD: '4C27',
  TEXT_LEAD: 'D507',
  SHARE_CAR: '512C',
  PHONE_LEAD_MOBILE: 'F757',
  CREDIT_APP: 'TDV1',
  PSX_MAKE_OFFER: 'PS10',
  PSX_TEST_DRIVE: 'V3NH',
  PSX_CHAT_SELLER: 'GS6F'
};